import secureLocalStorage from "react-secure-storage";
import React, { Component } from 'react';
import "../../Styles/UploadData.scss";
import { Upload } from '@progress/kendo-react-upload';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import mitigations from './mitigations.json';

export class ImportData extends Component{
  render(){
    return(
      <div className="importdataCont">
        <h2>Import Data</h2>
        <div className="radioGroup">
          <div className="radioCont">
            <div className="form-check">
              <label className="form-check-label">
                <input type="radio" className="form-check-input" name="optradio"/>Risks
              </label>
            </div>
            <div className="form-check">
              <label className="form-check-label">
                <input type="radio" className="form-check-input" name="optradio"/>Mitigations
              </label>
            </div>
          </div>
          <div className="templateFileCont">
            <button>Download Template</button>
          </div>
        </div>
        <div className="impDataHead">
            <Upload
                batch={false}
                multiple={true}
                defaultFiles={[]}
                withCredentials={false}
                saveUrl={'https://demos.telerik.com/kendo-ui/service-v4/upload/save'}
                removeUrl={'https://demos.telerik.com/kendo-ui/service-v4/upload/remove'}
            />
        </div>

        <div className="TableCont">
          <div className="gridBox">
            <div className="tblCont dataGrids noPaddTop">
              <div className="rw-tab-content">
                <h4>Uploaded Data</h4>
                <Grid data={[ ...mitigations ]}>
                    <Column field="Risk" title="Risk" width="200" />
                    <Column field="Mitigation" title="Action" width="250" />
                    <Column field="Control" title="Description" />
                    <Column field="Owner" title="Owner" />
                    <Column field="Cost" title={ "Cost of Action / "+secureLocalStorage.getItem("currency")} />
                    
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


